<template>
    <el-scrollbar class="task-detail">
        <div class="task-box" :key="key">
            <!-- 任务企业详情 -->
            <div class="task-header">
                <div class="header-title">{{ taskData?.task_name }}</div>

                <div class="desc-item">
                    <div class="desc-item_label">{{ taskData?.user_type === 1 ? "发布教师：" : "发布企业：" }}</div>
                    <div class="desc-item_value">{{ taskData?.user_info?.name }}</div>
                </div>

                <div class="desc-item">
                    <div class="desc-item_label">发布时间：</div>
                    <div class="desc-item_value">{{ taskData?.create_time }}</div>
                </div>

                <div class="desc-item">
                    <div class="desc-item_label">期望完成日期：</div>
                    <div class="desc-item_value">{{ taskData?.task_end_time?.split(" ")?.[0] ?? taskData?.task_end_time }}</div>
                </div>

                <div class="header-bottom">
                    <div class="bottom-tags">
                        <div class="tag-item normal">{{ taskData?.user_type === 1 ? "教师需求" : "企业需求" }}</div>
                        <div class="tag-item success">{{ taskData?.task_mode === 1 ? "招募" : "竞单" }}</div>
                        <div class="tag-split"></div>
                        <div class="tag-item danger">{{ taskData?.task_type_info?.name }}</div>
                        <div class="tag-item normal">
                            <template v-if="taskData?.task_status === 1">报名中</template>
                            <template v-else-if="taskData?.task_status === 2">进行中</template>
                            <template v-else-if="taskData?.task_status === 3">圆满结束</template>
                        </div>
                    </div>

                    <div class="bottom-end flex-center">
                        <div :class="['time-label', timeLabel.type]">
                            {{ timeLabel.label }}
                        </div>

                        <div
                            :class="['operate-btn', btn.type]"
                            v-for="btn in headerBtnList"
                            :key="btn.key"
                            @click="handleCallback(btn.callback)"
                        >
                            {{ btn.label }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 进度条 -->
            <div class="task-process">
                <div class="task-process_top">
                    <div
                        class="process-point"
                        v-for="(point, index) in processMap[taskData?.task_mode]"
                        :key="point.status"
                        :style="{ '--step': processMap[taskData?.task_mode].length - 1 }"
                    >
                        <i :class="[{ active: index < taskProcess }]"></i>

                        <div
                            :class="['point-line', { active: index < taskProcess - 1 }]"
                            v-if="index < processMap[taskData?.task_mode].length - 1"
                        ></div>
                    </div>
                </div>

                <div class="task-process_bottom">
                    <div class="process-name" v-for="point in processMap[taskData?.task_mode]" :key="point.status">{{ point.label }}</div>
                </div>
            </div>

            <!-- tab列表 -->
            <div class="task-tab">
                <div class="task-tab_top">
                    <div
                        :class="['tab-item', { active: tab.id === currentTab }]"
                        v-for="tab in tabList"
                        :key="tab.id"
                        @click="
                            () => {
                                currentTab = tab.id;
                                key += 1;
                            }
                        "
                    >
                        {{ tab.label }}
                    </div>
                </div>
            </div>

            <!-- tab对应的内容 -->
            <component
                :is="currentComponent"
                :task-data="taskData"
                :apply-list="applyList"
                :result-list="resultList"
                @changeStatus="handleChangePlanStatus"
                @statusAction="handleStatusAction"
            ></component>

            <TaskDialogBox ref="dialogBoxRef" :task-data="taskData" @update="handleUpdateData"></TaskDialogBox>
        </div>
    </el-scrollbar>
</template>

<script>
import taskApi from "@/apis/task";
import DetailOverview from "./modules/apply/DetailOverview.vue";
import AllCandidates from "./modules/apply/AllCandidates.vue";
import ProgressResult from "./modules/apply/ProgressResult.vue";
import { getTimeLabel, request } from "./util";
import TaskDialogBox from "./modules/TaskDialogBox.vue";
import { isEmpty } from "@/utils/common";

export default {
    data() {
        return {
            key: 1,
            role: Number(localStorage.getItem("role")), // 用户角色
            user_id: Number(localStorage.getItem("id")), // 用户id
            task_id: Number(this.$route.query.id),
            taskData: {}, // 任务需求数据
            applyList: [], // 任务报名列表
            resultList: [], // 进度与成果
            currentTab: 1, // 当前选中tab

            // 进度条
            processMap: {
                1: [
                    { status: 1, label: "报名" },
                    { status: 2, label: "需求方甄选" },
                    { status: 3, label: "签订合同" },
                    { status: 4, label: "接单方工作" },
                    { status: 5, label: "验收交付成功" },
                    { status: 6, label: "酬劳结算" },
                    { status: 7, label: "评价" },
                ],
                2: [
                    { status: 1, label: "交稿" },
                    { status: 2, label: "需求方甄选" },
                    { status: 3, label: "中标公示" },
                    { status: 4, label: "验收交付成功" },
                    { status: 5, label: "酬劳结算" },
                    { status: 6, label: "评价" },
                ],
            },

            // 流程操作按钮
            processBtnMap: {
                2: [
                    { key: "termina-contract", label: "终止合同", type: "normal", callback: "endContract" },
                    { key: "sign-contract", label: "签订合同", type: "primary", callback: "signContract" },
                ],
                3: [{ key: "deliver", label: "交付", type: "primary", callback: "submitTaskResult" }],
                4: [{ key: "rating", label: "评价", type: "primary", callback: "rating" }],
                5: [{ key: "re-deliver", label: "重新交付", type: "primary", callback: "submitTaskResult" }],
                8: [{ key: "sign-contract", label: "签订合同", type: "primary", callback: "signContract" }],
                13: [
                    { key: "return", label: "返工", type: "normal", callback: "rework" },
                    { key: "pass", label: "验收通过", type: "primary", callback: "passWork" },
                ],
            },

            request: request(),
        };
    },

    components: {
        TaskDialogBox,
    },

    computed: {
        // 是否为超管
        isAdmin() {
            return [1, 2].includes(this.role);
        },

        // 当前组件
        currentComponent() {
            const componentMap = {
                1: DetailOverview,
                2: AllCandidates,
                3: ProgressResult,
            };

            return componentMap[this.currentTab];
        },

        // 当前详情tab列表
        tabList() {
            const list = [
                { id: 1, label: "需求概览" },
                { id: 2, label: "全部人选" },
            ];

            if (this.role === 4) {
                // 学生，需要中标才有进度
                if (this.taskData?.accepted_user_id === this.user_id) list.push({ id: 3, label: "进度和成果" });
            } else {
                // 其他角色，需要是自己发布的才可以获取进度
                if (this.user_id === this.taskData?.user_id || this.isAdmin) list.push({ id: 3, label: "进度和成果" });
            }

            return list;
        },

        // header btn list
        headerBtnList() {
            // 如果是超管，没有操作按钮
            if (this.isAdmin) return [];

            // 当前时间大于预计完成时间 | 已经中标了，但是该学生没有中标 --不需要按钮
            if (this.dateTime.isExpire || (this.taskData?.accepted_user_id && !this.isOwnTask)) {
                return [];
            }

            // 报名操作
            const taskMode = this.taskData?.task_mode;
            const modeLabel = taskMode === 1 ? "报名" : "交稿"; // 模式label
            const isModify = this.taskData?.other_data?.modify_count > 0; // 是否可以修改报名，一个用户只能修改两次报名
            const isCancel = this.taskData?.other_data?.cancel_count > 0; // 是否可以取消报名，一个用户只能取消一次报名

            const signupBtnMap = {
                0: [{ key: "sign", label: `重新${modeLabel}`, type: "primary", callback: "reSign", disabled: !isModify }],
                1: [{ key: "re-sign", label: `重新${modeLabel}`, type: "normal", callback: "reSign", disabled: !isModify }],
                6: [
                    {
                        key: "cancel-sign",
                        label: `取消${modeLabel}`,
                        type: "normal",
                        callback: "cancelSign",
                        disabled: !isCancel || taskMode === 2, // 没有取消次数，模式为竞单不显示
                    },
                    { key: "update-sign", label: `修改${modeLabel}`, type: "primary", callback: "updateSign", disabled: !isModify },
                ],
            };

            // 按钮列表 - 报名时间已过则不需要报名相关操作
            let btnMap = !this.dateTime.isStopSign
                ? { ...this.processBtnMap, ...signupBtnMap }
                : { ...this.processBtnMap, 1: signupBtnMap["1"] };

            // 不同角色可使用的按钮列表
            const roleBtns = {
                1: [], // 超管
                2: [], // 学校管理员
                3: [8, 13], // 教师
                4: [0, 1, 2, 3, 4, 5, 6], // 学生
                5: [8, 13], // 企业
            };

            const todoKey = this.taskData?.task_todos?.todo_key;

            if (isEmpty(todoKey)) {
                // todokey没有值，说明没有进行任何操作，学生未报名 | 报名时间未截止
                return !this.dateTime.isStopSign ? [{ key: "sign", label: `${modeLabel}`, type: "primary", callback: "sign" }] : [];
            } else {
                // 有值走列表数据, 需要是对应角色按钮列表
                if (roleBtns[this.role].includes(todoKey)) return btnMap[todoKey]?.filter((item) => !item.disabled) ?? [];
            }
        },

        // 顶部时间label
        timeLabel() {
            let label = "";
            let type = "normal"; // danger-红字，normal-正常颜色
            const mode = this.taskData?.task_mode; // 需求模式

            const startLabel = `${mode === 1 ? "报名" : "交稿"}截止时间：${getTimeLabel(this.taskData?.task_start_time)}`;
            const endLabel = `预计完成时间：${getTimeLabel(this.taskData?.task_end_time)}`;

            // 报名阶段： process = 1
            if (this.taskData?.task_progress <= 2) {
                label = startLabel;

                if (this.dateTime.isStopSign) {
                    // 报名时间已过
                    type = "danger";

                    // 学生根据报名情况增加截止错失提示
                    if (this.isStudent) {
                        label += `(${this.isSignup ? "已截止" : "已错失"})`;
                    }
                }
            } else {
                // 进行阶段
                if (this.isStudent && !this.isSignup) {
                    // 学生，但是未报名
                    label = startLabel + "(已错失)";
                    type = "danger";
                } else {
                    label = endLabel;
                }

                if (this.dateTime.isExpire) {
                    label += "(已超期)";
                    type = "danger"; // 超过交付时间
                }
            }

            return { label, type };
        },

        // 时间参数
        dateTime() {
            const date = {
                now: Date.now(), // 当前时间
                start: new Date(this.taskData?.task_start_time).getTime(), // 报名截止时间
                end: new Date(this.taskData?.task_end_time).getTime(), // 预计完成时间
            };
            return {
                now: date.now,
                start: date.start,
                end: date.end,
                isStopSign: date.now > date.start, // 是否截止报名
                isExpire: date.now > date.end, // 是否已经过期
            };
        },

        // 是否为自己的任务 - 用于判断某些参数
        isOwnTask() {
            if (!this.taskData) return false;

            // 不为学生，或者中标id是自己
            return !this.isStudent || this.taskData?.accepted_user_id === this.user_id;
        },

        // 是否报名
        isSignup() {
            const isApplyRecord = this.applyList.some((item) => item.user_id === this.user_id); // 是否有报名记录
            const isAngin = [0].includes(this.taskData?.task_todos?.todo_key); // 是否需要重新报名，0-取消报名，1-被备选

            return isApplyRecord && !isAngin;
        },

        // 是否是学生
        isStudent() {
            return this.role === 4;
        },

        // 进度条
        taskProcess() {
            // 不为学生 | 学生中标
            if (!this.isStudent || this.isOwnTask) {
                // 企业有人报名则显示甄选阶段，没人报名显示报名阶段。学生需中标才走此逻辑
                const maxProgress = this.applyList.length > 0 ? 2 : 1;
                return Math.max(this.taskData?.task_progress, maxProgress);
            }

            // 学生，报名会显示需求甄选阶段，未报名则是报名阶段
            return this.isSignup ? 2 : 1;
        },
    },

    methods: {
        // 任务详情
        getDetail() {
            const params = {
                id: this.task_id,
            };

            return new Promise((resolve) => {
                this.request.axiosGetBy(taskApi.getTask, params, (res) => {
                    if (res.code === 200) {
                        this.taskData = res.data;

                        resolve(res.data);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            });
        },

        // 获取报名列表
        getApplyList() {
            const params = {
                task_id: this.task_id,
            };

            this.request.axiosGetBy(taskApi.taskApplyList, params, (res) => {
                if (res.code === 200) {
                    this.applyList = res.data?.all || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 获取进度与成果
        getResultList() {
            // 如果是学生，且中标不是自己，则不获取进度
            if (!this.isOwnTask) return;

            const params = {
                task_id: this.task_id,
            };

            this.request.axiosPost(taskApi.taskResultList, params, (res) => {
                if (res.code === 200) {
                    this.resultList = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 按钮事件回调
        handleCallback(callback) {
            const eventDistribute = this.$refs.dialogBoxRef?.eventDistribute;

            // 报名相关操作
            if (["sign", "reSign", "cancelSign", "updateSign"].includes(callback)) {
                // 取消报名
                if (callback === "cancelSign") {
                    this.cancelTaskApply();
                } else {
                    eventDistribute?.("handleSignup", [callback]);
                }
            }

            // 签合同
            if (callback === "signContract") {
                eventDistribute?.("handleSignContract");
            }

            // 学生交付结果
            if (callback === "submitTaskResult") {
                eventDistribute?.("handleSubmitResult");
            }

            // 终止合同 | 返工 | 验收通过 |学生评价
            if (["endContract", "rework", "passWork", "rating"].includes(callback)) {
                const funcArgMap = {
                    endContract: ["end"],
                    rework: ["return"],
                    passWork: ["pass"],
                    rating: ["rating"],
                };

                eventDistribute?.("handleStatusAction", funcArgMap[callback]);
            }
        },

        // 更新页面数据
        handleUpdateData(callbacks) {
            for (let i = 0; i < callbacks.length; i++) {
                this[callbacks[i]]?.();
            }
        },

        // 修改计划状态, 中标-淘汰-备选
        handleChangePlanStatus(api, params, callbacks) {
            this.$refs.dialogBoxRef?.eventDistribute?.("acceptanceAction", [api, params, callbacks]);
        },

        // 淘汰备选回调
        handleStatusAction(type, plan) {
            this.$refs.dialogBoxRef?.eventDistribute?.("handleStatusAction", [type, plan]);
        },

        // 取消报名
        cancelTaskApply() {
            this.$confirm("取消报名下次重新报名将不能取消报名，确定要取消报名吗？", "取消报名", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
                customClass: "ek-confirm warning",
            }).then(() => {
                const params = { task_id: this.task_id };

                this.request.axiosPost(taskApi.taskCancelApply, params, (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.message);
                        this.handleUpdateData(["getDetail", "getApplyList"]);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            });
        },
    },

    async created() {
        if (this.$route.query.id) {
            await this.getDetail();
            this.getApplyList();
            this.getResultList();
        }
    },
};
</script>

<style lang="scss" scoped>
.task-detail {
    // padding-top: 20px;
    height: 100%;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;
        overflow-x: hidden;
        box-sizing: border-box;

        &::-webkit-scrollbar {
            display: none;
        }

        .el-scrollbar__view {
            padding-block: 20px;
        }
    }

    .task-box {
        width: 1200px;
        margin: 0 auto;

        .task-header {
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            background-color: #ffffff;
            padding: 24px 34px;

            .header-title {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 20px;
                color: #333333;
            }

            .desc-item {
                margin-top: 20px;
                display: flex;
                align-items: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #333333;

                &_value {
                    color: #666666;
                }
            }

            .header-bottom {
                margin-top: 20px;
                display: flex;
                justify-content: space-between;

                .bottom-tags {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 10px;

                    .tag-item {
                        padding: 5px 10px;
                        border-radius: 4px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;

                        &.normal {
                            background: #ecf5ff;
                            border: 1px solid #b3d8ff;
                            color: #4b9fff;
                        }

                        &.danger {
                            background: #fef1f1;
                            border: 1px solid #fde2e2;
                            color: #f56c6c;
                        }

                        &.success {
                            background: #f6ffed;
                            border: 1px solid #01a04b;
                            color: #6bc45c;
                        }
                    }

                    .tag-split {
                        width: 1px;
                        height: 30px;
                        background: #eaeaea;
                    }
                }

                .bottom-end {
                    // width: 224px;

                    gap: 16px;

                    .time-label {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #ffa72b;

                        &.danger {
                            color: #ff0000;
                        }
                    }

                    .operate-btn {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 120px;
                        height: 40px;
                        border-radius: 20px;
                        background: #f4f5f5;
                        font-weight: 400;
                        font-size: 16px;
                        color: #6b7075;
                        cursor: pointer;

                        &.primary {
                            background: linear-gradient(270deg, #594fed 0%, #291ce7 100%);
                            color: #ffffff;
                        }
                    }
                }
            }
        }

        .task-process {
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            width: 100%;
            height: 124px;
            background-color: #ffffff;
            margin-top: 20px;
            padding-inline: 40px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 16px;

            &_top,
            &_bottom {
                width: 100%;
                display: flex;
                justify-content: space-between;

                .process-point,
                .process-name {
                    width: 90px;
                    display: flex;
                    justify-content: center;
                }
            }

            &_top {
                .process-point {
                    position: relative;

                    i {
                        width: 8px;
                        height: 8px;
                        background: #bfbfbf;
                        border-radius: 50%;

                        &.active {
                            background: #4f61f1;
                        }
                    }

                    .point-line {
                        --width: calc((1120px - (var(--step) + 1) * 8px - 82px) / var(--step));
                        position: absolute;
                        width: var(--width);
                        height: 2px;
                        background: #e9e9e9;
                        top: 50%;
                        left: 0;
                        transform: translate(49px, -50%);

                        &.active {
                            background: #4f61f1;
                        }
                    }
                }
            }
        }

        .task-tab {
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            margin-top: 20px;
            // height: 110px;
            background-color: #ffffff;

            &_top,
            &_bottom {
                display: flex;
                align-items: center;
            }

            &_top {
                gap: 30px;
                height: 50px;
                border-bottom: 1px solid #e9e9e9;
                padding-inline: 40px;

                .tab-item {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    cursor: pointer;
                    border-bottom: 2px solid transparent;

                    &.active {
                        color: #4f61f1;
                        border-bottom: 2px solid #4f61f1;
                    }
                }
            }
        }
    }
}
</style>
